import { service } from '@/ajax/request'
import { Order, OrderSendExpress, OrderUpdateRemark } from '@/types/api/order'
import { Id } from '@/types/common'



// 获取订单列表
export const orderList = (params: Order = {}) => (
  service({
    url: '/oms/order/list',
    method: 'GET',
    params,
    type: 'form'
  })
)

// 查询单个订单信息
export const orderSelectOne = (params: Id) => (
  service({
    url: `/oms/order/selectOne/${params.id}`,
    method: 'GET'
  })
)

// 查询物流信息主订单物流信息
export const selectExpress = (params: Id) => (
  service({
    url: `/oms/order/selectExpress/${params.id}`,
    method: 'GET',
    type: 'form'
  })
)

// 查询物流信息通过Id
export const selectExpressByOrderId = (params: { orderId: number }) => (
  service({
    url: `/omsOrderExpress/selectExpressByOrderId`,
    method: 'GET',
    type: 'form',
    params
  })
)

// 查询根据主订单查子订单相关信息
export const selectOrderByMainId = (params: Id) => (
  service({
    url: `/oms/order/selectOrderByMainId/${params.id}`,
    method: 'GET',
    type: 'form'
  })
)

/**
 * 订单发货
 * @param {string} expressName 
 * @param {string} expressNo 
 * @param {number} orderid 
 * @param {string} shipperCode 
 */
export const orderSendExpress = (params: OrderSendExpress) => (
  service({
    url: `/oms/order/sendExpress`,
    method: 'POST',
    params
  })
)

// 修改订单表备注
export const orderUpdateRemark = (params: OrderUpdateRemark) => (
  service({
    url: `/oms/order/updateRemark/${params.id}`,
    method: 'POST',
    params: params.remark
  })
)

// 修改订单表状态 status = 7->已签收；status = 9->已完成；status = 11->已关闭；status = 13->无效订
export const orderUpdateStatus = (params: OrderUpdateRemark) => (
  service({
    url: `/oms/order/updateStatus/${params.id}`,
    method: 'POST',
    params: params.status
  })
)

// 获取订单退货列表
export const returnList = (params: Order = {}) => (
  service({
    url: `/oms/order/returnList`,
    method: 'get',
    params,
    type: 'form'
  })
)

// 订单汇总信息
export const summaryInfo = (params: Order = {}) => (
  service({
    url: `/oms/order/summaryInfo`,
    method: 'get',
    params
  })
)

// 订单退款汇总信息
export const returnSummaryInfo = () => (
  service({
    url: `/oms/order/returnSummaryInfo`,
    method: 'get'
  })
)

// 订单退款审核通过,发起退款
export const orderRefund = (params: { orderId: number, subOrderIds: number }) => (
  service({
    url: `/oms/order/refund`,
    method: 'POST',
    type: 'form',
    params
  })
)

// 拒绝订单退款
export const rejectRefund = (params: { orderId: number, subOrderIds: number }) => (
  service({
    url: `/oms/order/rejectRefund`,
    method: 'POST',
    type: 'form',
    params
  })
)

// 订单列表导出excel
export const exportOrderListInfo = (params: Order = {}) => (
  service({
    url: `/oms/order/excel/exportOrderListInfo`,
    method: 'GET',
    type: 'form',
    params,
    excel: true
  })
)

// 拒绝客户发起退货
export const rejectReturn = (params: { orderId: number, subOrderIds: number }) => (
  service({
    url: `/oms/order/rejectReturn`,
    method: 'POST',
    type: 'form',
    params
  })
)

// 同意客户发起退货
export const agreeReturn = (params: { orderId: number, subOrderIds: number }) => (
  service({
    url: `/oms/order/agreeReturn`,
    method: 'POST',
    type: 'form',
    params
  })
)

// 确认收到退的货物，进入退款审核流程
export const confirmTakeReturnGoods = (params: { orderId: number, subOrderIds: number }) => (
  service({
    url: `/oms/order/confirmTakeReturnGoods`,
    method: 'POST',
    type: 'form',
    params
  })
)

// 后台主动发起订单退款 subOrderId 子订单id
export const initiativeReturn = (params: { returnAmount: number, subOrderId: number }) => (
  service({
    url: `/oms/order/initiativeReturn/${params.subOrderId}`,
    method: 'GET',
    type: 'form',
    params:{
      returnAmount:params.returnAmount
    }
  })
)

// 获取订单退货订单详细，subOrderId 子订单id
export const orderReturnDetail = (params: {  subOrderId: number }) => (
  service({
    url: `/oms/order/orderReturnDetail/${params.subOrderId}`,
    method: 'GET'
  })
)

// 获取售后中的数量
export const getCountAfterSale = () => (
  service({
    url: `/oms/order/getCountAfterSale`,
    method: 'GET'
  })
)

// 获取待支付数量
export const getCountAwaitPay = () => (
  service({
    url: `/oms/order/getCountAwaitPay`,
    method: 'GET'
  })
)

// 获取待发货数量
export const getCountAwaitSend = () => (
  service({
    url: `/oms/order/getCountAwaitSend`,
    method: 'GET'
  })
)

// 修改发货方式 1，快递发货 -2门店自提 二选一
export const updateShippingMethod = (params: { orderId: number, status: number }) => (
  service({
    url: `/oms/order/updateShippingMethod/${params.orderId}`,
    method: 'POST',
    type:'string',
    params:params.status
  })
)